var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container bio"},[_vm._l((_vm.entries),function(entry){return _c('bio-entry',{key:entry.title,attrs:{"entry":entry}})}),_c('url',{attrs:{"to":{ name: 'home' },"internal":"","dark":""}},[_vm._v("Back")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }